// Vendor libraries
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class LoadingSymbolModule {
}
LoadingSymbolModule.ɵfac = function LoadingSymbolModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoadingSymbolModule)(); };
LoadingSymbolModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LoadingSymbolModule });
LoadingSymbolModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
